<template>
  <div class="each-order" :data-mode="order.order_type" v-if="order">
    <el-row class="order-header" :gutter="20">
      <el-col :lg="6">
        <h4 class="order-title"># ORDER ID</h4>
        <p class="order-data">#{{ order.id }}</p>
      </el-col>
      <el-col :lg="6" v-if="order.order_type === 'stripe'">
        <h4 class="order-title">Payment Status</h4>
        <p class="order-data green text-uppercase">{{ order.payment_status }}</p>
      </el-col>
      <el-col :lg="6" v-else>
        <h4 class="order-title">Transaction Number</h4>
        <p class="order-data green text-uppercase word-break">{{ order.transaction_ref_no }}</p>
      </el-col>
      <el-col :lg="6">
        <h4 class="order-title">Order Status</h4>
        <p class="order-data orange text-uppercase">{{ order.order_status }}</p>
      </el-col>
      <el-col :lg="6">
        <h4 class="order-title">Order Date</h4>
        <p class="order-data">{{ dateFormat(order.created_at) }}</p>
      </el-col>
    </el-row>
    <el-row :gutter="30" class="each-order-address-block">
      <el-col :lg="12">
        <h4 class="order-title">Billing address</h4>
        <div class="order-data">
          <address class="word-break">
            {{ order.billing_address.address || order.shipping_address.address }}
          </address>
        </div>
      </el-col>
      <el-col :lg="12">
        <h4 class="order-title">Shipping address</h4>
        <div class="order-data">
          <address class="word-break">
            {{ order.shipping_address.address }}
          </address>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="30" class="each-order-address-block">
      <el-col :lg="8">
        <h4 class="order-title">Sub Total</h4>
        <p class="order-data bold">{{ order.display_sub_total }}</p>
      </el-col>
      <el-col :lg="8">
        <h4 class="order-title">Shipping Cost</h4>
        <p class="order-data bold">{{ order.display_shipping_cost }}</p>
      </el-col>
      <el-col :lg="8">
        <h4 class="order-title">Total</h4>
        <p class="order-data bold">{{ order.display_total_price }}</p>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-10">
      <el-col :lg="24">
        <h4 class="order-title">Order Items</h4>
        <el-table
          :data="order.items"
          empty-text="No order items found"
          style="width: 98%">
          <el-table-column
            label="Product Name"
          >
            <template slot-scope="{ row }">
              <router-link class="product-link"
                           :to="{ name: 'product-details', params: { slug: row.product.slug }}">{{
                  row.product.name
                }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            prop="qty"
            label="Quantity">
          </el-table-column>
          <el-table-column
            align="right"
            prop="display_unit_price"
            label="Unit Price">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "OrderCard",
  props: {
    order: {
      type: Object,
      required: true,
    }
  },
  methods: {
    dateFormat(order_date) {
      return moment(order_date).format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped lang="scss">
.each-order {
  position: relative;
  border: 1px solid #efefe2;
  padding: 30px 20px;
  margin-bottom: 40px;
  overflow: hidden;

  &:after {
    position: absolute;
    content: attr(data-mode);
    right: 0;
    top: 0;
    writing-mode: vertical-rl;
    text-orientation: upright;
    text-align: center;
    width: 25px;
    font-weight: 400;
    font-family: sans-serif;
    background: beige;
    height: 100%;
  }

  .order-header {
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
  }

  .order-title {
    font-size: 14px;
    line-height: 13px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #4d4d4d;
    font-weight: 500;
    margin-bottom: 15px;
  }

  .green {
    color: #12ab0f !important;
    font-weight: 500;
  }

  .bold {
    font-weight: 600;
  }

  .orange {
    color: #eeae31 !important;
    font-weight: 500;
  }

  .order-data {
    color: #7b7b7b;
    font-size: 13px;
  }

  .each-order-address-block {
    margin-top: 20px;

    address {
      font-style: normal;

      p {
        margin: 0;
      }
    }
  }
}

.orient {
  text-orientation: upright;
  writing-mode: vertical-lr;
}

.product-link {
  word-break: break-all;
  font-weight: 400;
  color: #333;
}
</style>
